﻿import React from 'react';
import { Feather } from '../../helpers/Feather';
import { formatPrice } from '../../helpers/Formatters';

export function CartTotal(props: { items: number; total: number }) {
    if (props.total === 0) {
        return (
            <a className="nav-link nav-cart" href="/Shop/Cart">Your Cart <span className="cart-icon"><Feather icon="shopping-cart" size={24} /></span></a>
        );
    }
    else {
        const price = formatPrice(props.total);
        return (
            <a className="nav-link nav-cart" href="/Shop/Cart">Your Cart <span className="cart-icon"><Feather icon="shopping-cart" size={24} /><span className="cart-badge">{props.items}</span></span> {price}</a>
        );
    }   
}